// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__76gC2","nav1":"Navbar_nav1__KgPMK","logo":"Navbar_logo__nfLNF","nav1H":"Navbar_nav1H__DZ351","anchor":"Navbar_anchor__OOsec","nav2":"Navbar_nav2__k1eUw"};